import { gql } from '@apollo/client'

export const CREATE_AVAILABILITY_MUTATION = gql`
  mutation CreateAvailability(
    $providerId: ID!
    $eventStartsAt: ISO8601DateTime!
    $eventEndsAt: ISO8601DateTime!
    $guestCount: Int!
  ) {
    createMeetingpackageAvailability(
      input: {
        providerId: $providerId
        eventTimeRange: {
          startsAt: $eventStartsAt
          endsAt: $eventEndsAt
        }
        guestCount: $guestCount
      }
    ) {
      availability {
        availabilityId
        isInstantBookable
        grossPrice
        netPrice
      }
    }
  }
`

export const GET_AVAILABILITY_PRICE = gql` query GetAvailabilityPrice { availabilityPrice @client }`
